import { TaskContainerSectionProperties } from './section-types';
import { TaskSectionType } from './task-section-type.enum';

export interface TaskSectionPropertiesBase {
  sectionTitle: string;
  placeholderLabel?: string;
}

export type TaskSection<T extends TaskSectionPropertiesBase = TaskSectionPropertiesBase> =
  | TaskFieldSection<T>
  | TaskContainerSection;

export interface TaskFieldSection<T extends TaskSectionPropertiesBase = TaskSectionPropertiesBase> {
  id: string;
  type: Exclude<TaskSectionType, TaskSectionType.Container>;
  properties: T;
}

export interface TaskContainerSection {
  id: string;
  type: TaskSectionType.Container;
  properties: TaskContainerSectionProperties;
  sections: TaskFieldSection[];
}

export const isContainerSection = (section: TaskSection): section is TaskContainerSection =>
  section.type === TaskSectionType.Container;
